module.exports = __webpack_public_path__ + "static/media/test16_3.914a2652.png";